module.exports = require("@swa-ui/dotcom/src/NotificationCenter/NotificationCenter.module.scss");